// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen1_comp__U4M9P"};